import { ReactNode } from 'react';

import { Text, Colors, SchoolIcons } from '@rockalingua/ui';

import { Container, MainContent, IconsContainer } from './TrustedBy.styled';

type TrustedByProps = {
  title: string;
  button: ReactNode;
};

export default function TrustedBy({ title, button }: TrustedByProps) {
  return (
    <Container>
      <MainContent>
        <Text variant="title-big-grey-42" color={Colors.BLACK}>
          {title}
        </Text>
        {button}
      </MainContent>
      <IconsContainer>
        <SchoolIcons />
      </IconsContainer>
    </Container>
  );
}
